import { TAGButton } from '@aspendental/shared-components-web';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Box, DialogContent, Divider, Typography } from '@mui/material';
import { dialogStyles } from '../SelectLocationDialog.styles';
import { CenterLocation } from 'types/location';
interface IRestApiLocationsList {
  locations: CenterLocation[];
  heartedLocation: string;
  searchTerm: string;
  toggleHeart: (locationId: string) => void;
  handleLocationChange: (location: CenterLocation) => void;
}
export default function RestApiLocationsList({
  locations,
  heartedLocation,
  searchTerm,
  toggleHeart,
  handleLocationChange
}: IRestApiLocationsList) {
  const filteredLocations = locations?.filter(location => location.display_name.toLowerCase().includes(searchTerm.toLowerCase()) || location.address_info?.zip_code.includes(searchTerm)) || [];
  const sortedLocations = filteredLocations.toSorted((a, b) => {
    const isAHearted = a.id === heartedLocation;
    const isBHearted = b.id === heartedLocation;
    if (isAHearted && !isBHearted) return -1;
    if (!isAHearted && isBHearted) return 1;
    return a.display_name.localeCompare(b.display_name);
  });
  if (!sortedLocations.length) {
    return <Typography variant="bodyMediumBook" fontWeight="normal" data-test-id="no-locations-found">
				No locations found
			</Typography>;
  }
  return <DialogContent sx={dialogStyles.dialogContent} data-test-id="dialog-content" data-sentry-element="DialogContent" data-sentry-component="RestApiLocationsList" data-sentry-source-file="RestApiLocationsList.tsx">
			{sortedLocations.map((location, index) => <Box key={location.id} sx={dialogStyles.locationBox} data-test-id={`location-box-${location.code}`}>
					<Typography variant="bodySmallBold" fontWeight="bold" sx={dialogStyles.locationName} data-test-id={`location-name-${location.code}`}>
						<FavoriteIcon sx={dialogStyles.favoriteIcon(location.id === heartedLocation)} onClick={() => toggleHeart(location.id)} data-test-id={`favorite-icon-${location.code}`} aria-label={`Heart location ${location.display_name}`} />
						{location.display_name}
					</Typography>
					{location.address_info && <Typography variant="bodySmallBook" sx={dialogStyles.locationAddress} data-test-id={`location-address-${location.code}`}>
							{location.address_info.address_1}
						</Typography>}
					<TAGButton variant="secondaryDefault" sx={dialogStyles.selectButton} size="S" onClick={() => handleLocationChange(location)} dataTestId={`select-button-${location.code}`} aria-label={`Select location ${location.display_name}`}>
						Select
					</TAGButton>
					{index < sortedLocations.length - 1 && <Divider sx={dialogStyles.divider} data-test-id={`divider-${location.code}`} />}
				</Box>)}
		</DialogContent>;
}